// import React, { useState, useEffect } from 'react';
// import { useParams, useNavigate } from 'react-router-dom';
// import axios from 'axios';
// import '../App.css';
// import SharedNavbar from '../components/SharedNavbar';
// import Footer from '../components/Footer';
// import StarfieldBackground from '../components/StarfieldBackground';

// const BlogPostPage = () => {
//     const { slug } = useParams();
//     const navigate = useNavigate();
//     const [blog, setBlog] = useState(null);
//     const [loading, setLoading] = useState(true);
//     const [error, setError] = useState(null);

//     const BASE_URL = 'http://localhost:5000';

//     useEffect(() => {
//         const fetchBlog = async () => {
//             try {
//                 const response = await axios.get(`${ BASE_URL }/api/blogs/${ slug }`);
//                 if (response.data.success) {
//                     setBlog(response.data.data);
//                 } else {
//                     setError('Blog not found');
//                 }
//             } catch (err) {
//                 console.error("Error fetching blog:", err);
//                 setError('Error loading blog post.');
//             } finally {
//                 setLoading(false);
//             }
//         };

//         fetchBlog();
//     }, [slug]);

//     const getImageUrl = (imagePath) => {
//         if (!imagePath) return 'https://via.placeholder.com/1200x600?text=Moonshot';
//         if (imagePath.startsWith('http')) return imagePath;
//         return `${ BASE_URL }${ imagePath }`;
//     };

//     const handleShare = async () => {
//         try {
//             if (navigator.share) {
//                 await navigator.share({
//                     title: blog.title,
//                     text: blog.excerpt,
//                     url: window.location.href,
//                 });
//             } else {
//                 await navigator.clipboard.writeText(window.location.href);
//                 alert('Link copied to clipboard!');
//             }
//         } catch (err) {
//             console.error('Error sharing:', err);
//         }
//     };

//     if (loading) {
//         return (
//             <div style={{ minHeight: '100vh', backgroundColor: '#000', color: '#fff', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
//                 <div className="spinner"></div>
//             </div>
//         );
//     }

//     if (error || !blog) {
//         return (
//             <div style={{ minHeight: '100vh', backgroundColor: '#000', color: '#fff', display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', gap: '20px' }}>
//                 <h2>{error || 'Blog not found'}</h2>
//                 <button onClick={() => navigate('/blog')} style={{ padding: '10px 20px', background: 'white', color: 'black', border: 'none', borderRadius: '8px', cursor: 'pointer' }}>
//                     Back to Blogs
//                 </button>
//             </div>
//         );
//     }

//     return (
//         <div style={{ position: 'relative', minHeight: '100vh', backgroundColor: '#000', color: '#fff', display: 'flex', flexDirection: 'column' }}>
//             {/* Background */}
//             <div style={{ position: 'fixed', inset: 0, zIndex: 0, pointerEvents: 'none', opacity: 0.8 }}>
//                 <StarfieldBackground />
//             </div>

//             <div style={{ position: 'relative', zIndex: 1, display: 'flex', flexDirection: 'column', flex: 1 }}>
//                 <SharedNavbar />

//                 <div style={{ flex: 1, paddingTop: '120px', paddingBottom: '80px' }}>
//                     <div style={{ maxWidth: '900px', margin: '0 auto', padding: '0 20px' }}>

//                         {/* Back Nav */}
//                         <button
//                             onClick={() => navigate('/blog')}
//                             style={{
//                                 background: 'rgba(255,255,255,0.05)',
//                                 border: '1px solid rgba(255,255,255,0.1)',
//                                 borderRadius: '100px',
//                                 color: 'rgba(255,255,255,0.8)',
//                                 cursor: 'pointer',
//                                 display: 'inline-flex',
//                                 alignItems: 'center',
//                                 gap: '8px',
//                                 fontSize: '0.9rem',
//                                 marginBottom: '40px',
//                                 padding: '8px 16px',
//                                 transition: 'all 0.2s',
//                                 backdropFilter: 'blur(5px)'
//                             }}
//                             onMouseEnter={(e) => {
//                                 e.currentTarget.style.background = 'rgba(255,255,255,0.1)';
//                                 e.currentTarget.style.borderColor = 'rgba(255,255,255,0.3)';
//                             }}
//                             onMouseLeave={(e) => {
//                                 e.currentTarget.style.background = 'rgba(255,255,255,0.05)';
//                                 e.currentTarget.style.borderColor = 'rgba(255,255,255,0.1)';
//                             }}
//                         >
//                             <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//                                 <path d="M19 12H5M12 19l-7-7 7-7" />
//                             </svg>
//                             Back to Insights
//                         </button>

//                         {/* Blog Header */}
//                         <div style={{ textAlign: 'center', marginBottom: '50px', animation: 'fadeInUp 0.6s ease-out' }}>
//                             <div style={{ display: 'flex', gap: '10px', justifyContent: 'center', marginBottom: '24px' }}>
//                                 {blog.tags?.map((tag, i) => (
//                                     <span key={i} style={{
//                                         background: 'rgba(77, 172, 255, 0.1)',
//                                         border: '1px solid rgba(77, 172, 255, 0.3)',
//                                         color: '#4dacff',
//                                         padding: '6px 16px',
//                                         borderRadius: '100px',
//                                         fontSize: '0.85rem',
//                                         fontWeight: '600',
//                                         textTransform: 'uppercase',
//                                         letterSpacing: '0.05em'
//                                     }}>
//                                         {tag}
//                                     </span>
//                                 ))}
//                             </div>

//                             <h1 style={{
//                                 fontSize: 'clamp(2.5rem, 5vw, 3.5rem)',
//                                 fontWeight: '800',
//                                 lineHeight: '1.2',
//                                 marginBottom: '24px',
//                                 background: 'linear-gradient(135deg, #fff 0%, #a6a6a6 100%)',
//                                 WebkitBackgroundClip: 'text',
//                                 WebkitTextFillColor: 'transparent',
//                                 letterSpacing: '-1px'
//                             }}>
//                                 {blog.title}
//                             </h1>

//                             <div style={{
//                                 display: 'flex',
//                                 alignItems: 'center',
//                                 justifyContent: 'center',
//                                 gap: '20px',
//                                 color: 'rgba(255,255,255,0.6)',
//                                 fontSize: '1rem'
//                             }}>
//                                 <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
//                                     <div style={{
//                                         width: '24px',
//                                         height: '24px',
//                                         borderRadius: '50%',
//                                         background: 'linear-gradient(45deg, #4dacff, #007cc3)',
//                                         display: 'flex',
//                                         alignItems: 'center',
//                                         justifyContent: 'center',
//                                         fontSize: '0.7rem',
//                                         fontWeight: 'bold',
//                                         color: 'white'
//                                     }}>
//                                         {blog.author?.name ? blog.author.name.charAt(0) : 'M'}
//                                     </div>
//                                     <span>{blog.author?.name || 'Moonshot Team'}</span>
//                                 </div>
//                                 <span style={{ opacity: 0.3 }}>|</span>
//                                 <span>{new Date(blog.createdAt).toLocaleDateString()}</span>
//                                 <span style={{ opacity: 0.3 }}>|</span>
//                                 <span>{blog.readTime || 5} min read</span>
//                             </div>
//                         </div>

//                         {/* Cover Image */}
//                         <div style={{
//                             width: '100%',
//                             aspectRatio: '16/9',
//                             borderRadius: '24px',
//                             overflow: 'hidden',
//                             marginBottom: '60px',
//                             boxShadow: '0 20px 60px rgba(0,0,0,0.5)',
//                             border: '1px solid rgba(255,255,255,0.1)',
//                             animation: 'fadeInUp 0.8s ease-out'
//                         }}>
//                             <img
//                                 src={getImageUrl(blog.coverImage)}
//                                 alt={blog.title}
//                                 style={{ width: '100%', height: '100%', objectFit: 'cover' }}
//                             />
//                         </div>

//                         {/* Content */}
//                         <div style={{
//                             background: 'rgba(255,255,255,0.02)',
//                             borderRadius: '24px',
//                             padding: '40px',
//                             border: '1px solid rgba(255,255,255,0.05)',
//                             backdropFilter: 'blur(10px)',
//                             marginBottom: '60px'
//                         }}>
//                             <article
//                                 className="blog-content"
//                                 style={{
//                                     fontSize: '1.2rem',
//                                     lineHeight: '1.8',
//                                     color: 'rgba(255,255,255,0.9)'
//                                 }}
//                                 dangerouslySetInnerHTML={{ __html: blog.content }}
//                             />
//                         </div>

//                         {/* Gallery Images */}
//                         {blog.images && blog.images.length > 0 && (
//                             <div style={{ marginBottom: '80px', animation: 'fadeInUp 1s ease-out' }}>
//                                 <div style={{ display: 'flex', alignItems: 'center', gap: '16px', marginBottom: '30px' }}>
//                                     <h3 style={{ fontSize: '1.8rem', fontWeight: '700', margin: 0 }}>Gallery</h3>
//                                     <div style={{ height: '1px', flex: 1, background: 'rgba(255,255,255,0.1)' }}></div>
//                                 </div>

//                                 <div style={{
//                                     display: 'grid',
//                                     gridTemplateColumns: 'repeat(auto-fill, minmax(250px, 1fr))',
//                                     gap: '20px'
//                                 }}>
//                                     {blog.images.map((img, index) => {
//                                         // Skip cover image if it's in the array
//                                         if (img === blog.coverImage) return null;

//                                         return (
//                                             <div key={index} style={{
//                                                 borderRadius: '16px',
//                                                 overflow: 'hidden',
//                                                 aspectRatio: '1',
//                                                 boxShadow: '0 8px 24px rgba(0,0,0,0.3)',
//                                                 border: '1px solid rgba(255,255,255,0.1)',
//                                                 cursor: 'pointer'
//                                             }}>
//                                                 <img
//                                                     src={getImageUrl(img)}
//                                                     alt={`Gallery ${ index + 1 }`}
//                                                     style={{ width: '100%', height: '100%', objectFit: 'cover', transition: 'transform 0.4s ease' }}
//                                                     onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.1)'}
//                                                     onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
//                                                 />
//                                             </div>
//                                         );
//                                     })}
//                                 </div>
//                             </div>
//                         )}

//                         {/* Post-Footer Actions */}
//                         <div style={{
//                             borderTop: '1px solid rgba(255,255,255,0.1)',
//                             paddingTop: '40px',
//                             marginBottom: '80px',
//                             display: 'flex',
//                             justifyContent: 'space-between',
//                             alignItems: 'center'
//                         }}>
//                             <div style={{ color: 'rgba(255,255,255,0.5)', fontSize: '0.9rem' }}>
//                                 Posted in <strong>{blog.tags?.[0] || 'Uncategorized'}</strong>
//                             </div>

//                             <button
//                                 onClick={handleShare}
//                                 style={{
//                                     background: '#fff',
//                                     color: '#000',
//                                     padding: '12px 30px',
//                                     borderRadius: '100px',
//                                     cursor: 'pointer',
//                                     display: 'flex',
//                                     alignItems: 'center',
//                                     gap: '10px',
//                                     fontWeight: '700',
//                                     fontSize: '1rem',
//                                     border: 'none',
//                                     transition: 'transform 0.2s, box-shadow 0.2s'
//                                 }}
//                                 onMouseEnter={(e) => {
//                                     e.currentTarget.style.transform = 'translateY(-2px)';
//                                     e.currentTarget.style.boxShadow = '0 10px 20px rgba(255,255,255,0.2)';
//                                 }}
//                                 onMouseLeave={(e) => {
//                                     e.currentTarget.style.transform = 'translateY(0)';
//                                     e.currentTarget.style.boxShadow = 'none';
//                                 }}
//                             >
//                                 <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//                                     <path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8"></path>
//                                     <polyline points="16 6 12 2 8 6"></polyline>
//                                     <line x1="12" y1="2" x2="12" y2="15"></line>
//                                 </svg>
//                                 Share This Insight
//                             </button>
//                         </div>
//                     </div>
//                 </div>

//                 <Footer />
//             </div>
//         </div>
//     );
// };

// export default BlogPostPage;
import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import './BlogPostPage.css'; // Importing your new scoped CSS
import SharedNavbar from '../components/SharedNavbar';
import Footer from '../components/Footer';

const BlogPostPage = () => {
    const { slug } = useParams();
    const navigate = useNavigate();
    const [blog, setBlog] = useState(null);
    const [loading, setLoading] = useState(true);
    const [scrollProgress, setScrollProgress] = useState(0);

    const BASE_URL = 'http://localhost:5000';

    useEffect(() => {
        const handleScroll = () => {
            const totalScroll = document.documentElement.scrollTop;
            const windowHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight;
            setScrollProgress(`${ (totalScroll / windowHeight) * 100 }%`);
        };
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    useEffect(() => {
        const fetchBlog = async () => {
            try {
                const response = await axios.get(`${ BASE_URL }/api/blogs/${ slug }`);
                if (response.data.success) setBlog(response.data.data);
            } catch (err) {
                console.error("Error fetching blog:", err);
            } finally {
                setLoading(false);
            }
        };
        fetchBlog();
    }, [slug]);

    if (loading) {
        return (
            <div style={{ minHeight: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: '#fff', color: '#000' }}>
                <div className="spinner" style={{ border: '4px solid rgba(0,0,0,0.1)', borderLeftColor: '#000', borderRadius: '50%', width: '40px', height: '40px', animation: 'spin 1s linear infinite' }}></div>
                <style>{`@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }`}</style>
            </div>
        );
    }

    return (
        <div className="blog-page-container">
            <div className="reading-progress-bar" style={{ width: scrollProgress }} />

            <SharedNavbar activePage="blog" />

            <main className="blog-main-content">
                <div className="blog-inner-container">

                    <div className="blog-post-header">
                        <div style={{ display: 'flex', gap: '10px', justifyContent: 'center', marginBottom: '24px' }}>
                            {blog.tags?.map((tag, i) => (
                                <span key={i} className="blog-tag">{tag}</span>
                            ))}
                        </div>
                        <h1 className="premium-title">{blog.title}</h1>
                        <div className="author-meta">
                            <span>{blog.author?.name || 'Moonshot Team'}</span>
                            <span className="dot-separator">|</span>
                            <span>{new Date(blog.createdAt).toLocaleDateString()}</span>
                            <span className="dot-separator">|</span>
                            <span>{blog.readTime || 5} min read</span>
                        </div>

                        <div className="blog-top-actions">
                            <button className="back-btn" onClick={() => navigate('/blog')}>← Back</button>
                            <button className="share-btn" onClick={() => alert('Link Copied!')}>Share Insight</button>
                        </div>
                    </div>

                    <div className="featured-image-container">
                        <img src={blog.coverImage.startsWith('http') ? blog.coverImage : `${ BASE_URL }${ blog.coverImage }`} alt={blog.title} />
                    </div>

                    <div className="blog-body-wrapper">
                        {/* 
                            Custom Content Parser
                        */}
                        <div className="blog-rich-text">
                            {blog.content.split('\n').filter(line => line.trim() !== '').map((line, index) => {
                                // Simple heuristic for headers: Short lines ending with '?' or ':' or generally short uppercase.
                                const isHeader = (line.length < 100 && (line.trim().endsWith('?') || line.trim().endsWith(':')));
                                const isListItem = line.trim().startsWith('-');

                                if (isHeader) {
                                    return <h2 key={index}>{line}</h2>;
                                }
                                if (isListItem) {
                                    return (
                                        <ul key={index}>
                                            <li>{line.replace(/^-/, '').trim()}</li>
                                        </ul>
                                    );
                                }
                                return <p key={index}>{line}</p>;
                            })}
                        </div>

                        {/* Gallery Section */}
                        {blog.images && blog.images.length > 0 && (
                            <div className="blog-gallery-section">
                                <h3 className="gallery-title">Visuals</h3>
                                <div className="gallery-grid">
                                    {blog.images.map((img, index) => {
                                        // Helper: normalize URLs to compare
                                        const normalize = (url) => url.startsWith('http') ? url : `${ BASE_URL }${ url }`;
                                        const imgUrl = normalize(img);
                                        const coverUrl = normalize(blog.coverImage);

                                        // Skip if it's the cover image (to avoid duplication)
                                        if (imgUrl === coverUrl) return null;

                                        return (
                                            <div key={index} className="gallery-item">
                                                <img src={imgUrl} alt={`Gallery ${ index + 1 }`} loading="lazy" />
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                        )}

                    </div>
                </div>
            </main>
            <Footer />
        </div>
    );
};

export default BlogPostPage;